module.exports = __webpack_public_path__ + "static/chickenthighs-acaac5b457eab6e5df509ab128e848ab.jpg";